import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Shell } from './components/Shell';
import { Share } from './pages/Share';
import {
  AndroidDownload,
  CancelDeletion,
  DriverDownload,
  Contact,
  Cookies,
  Delivery,
  Demo,
  Desktop,
  DesktopDownload,
  Features,
  FleetOperations,
  FleetVisibility,
  FinanceReporting,
  Home,
  Integrations,
  Mobile,
  NotFound,
  PaymentComplete,
  Pricing,
  Privacy,
  Refunds,
  ResetPassword,
  SearchLanding,
  Support,
  Terms,
  Trial,
  WorkshopInventory,
  WebApp,
} from './pages/Pages';
import { searchPages } from './data/site';

export default function App() {
  return (
    <Routes>
      {/* Shared statements are documents sent to customers, not marketing pages, so they sit
          outside the site shell and carry their own minimal frame. */}
      <Route path="/s/:token?" element={<Share />} />
      <Route
        element={
          <Shell>
            <Outlet />
          </Shell>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/solutions/fleet-operations" element={<FleetOperations />} />
        <Route path="/solutions/finance-and-reporting" element={<FinanceReporting />} />
        <Route path="/solutions/fleet-visibility" element={<FleetVisibility />} />
        <Route path="/solutions/workshop-and-inventory" element={<WorkshopInventory />} />
        <Route path="/integrations" element={<Integrations />} />
        {searchPages.map(page => (
          <Route key={page.slug} path={`/${page.slug}`} element={<SearchLanding page={page} />} />
        ))}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/desktop" element={<Desktop />} />
        <Route path="/web" element={<WebApp />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/downloads/android" element={<AndroidDownload />} />
        <Route path="/downloads/driver" element={<DriverDownload />} />
        <Route path="/downloads/desktop" element={<DesktopDownload />} />
        <Route path="/request-demo" element={<Demo />} />
        <Route path="/start-trial" element={<Trial />} />
        <Route path="/cancel-deletion" element={<CancelDeletion />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/delivery" element={<Delivery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payment-complete" element={<PaymentComplete />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Route>
    </Routes>
  );
}
